import { createFileRoute } from "@tanstack/react-router";
import { MerchOrderDetail } from "../../components/merch/order-detail";

/** One store order: lines, delivery, payments, timeline and the desk's moves (`next_statuses`). */
export const Route = createFileRoute("/_app/merchandising/orders/$orderId")({
	component: OrderPage,
});

function OrderPage() {
	const { orderId } = Route.useParams();
	return <MerchOrderDetail key={orderId} orderId={orderId} />;
}
